<template>
	<div class="containerMain">
		<div class="col inner nofound">
			<h1>{{school.name}}</h1>
			<h3>Sin información de colegio</h3>
			<div class="nofoundImg"></div>
			<p>Hola, aún no contamos con evaluaciones, espere la próxima visita de su coach, Gracias</p>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		school () {
			return this.$store.state.persistent.school;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";

.nofound {
	& > h1 {
		margin: 5% 0;
		font-size: $xxBigSize;
		font-weight: 700;
		color: $semiBlack;
	}
	& > h3 {
		font-size: $bigTitle;
		color: $oxfordBlue;
		font-weight: 700;
	}
	&Img {
		background-color: $odd;
		background-image: url('../../assets/analysis.svg');
		background-repeat: no-repeat;
		background-position: center;
		border-radius: 20rem;
		margin: 2%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 16.7rem;
		height: 16.7rem;
	}
	& > p {
		font-size: $bigTitle;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/NoData.vue